import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const AUTONOMY_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Disability Forms",
    documentLabel: "{{ dateReceived YYYYMMDD }} Disability Form",
    folder: "Disability / FMLA",
    folderMapping: "Disability / FMLA",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "autonomy",
  },
  [Classification.CARE_PLAN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Care Plan",
    documentLabel: "{{ dateReceived YYYYMMDD }} Care Plan",
    folder: "Consultations / Follow Ups",
    folderMapping: "Consultations / Follow Ups",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CARE_PLAN,
    group: "autonomy",
  },
  [Classification.CLEARANCE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Clearance Request",
    documentLabel: "{{ dateReceived YYYYMMDD }} Clearance Request",
    folder: "Misc.",
    folderMapping: "Misc.",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST,
    group: "autonomy",
  },
  [Classification.CONSENT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Consents",
    documentLabel: "{{ dateReceived YYYYMMDD }} Consent",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CONSENT,
    group: "autonomy",
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Order Form for any DME",
    documentLabel: "{{ dateReceived YYYYMMDD }} DME Order",
    folder: "DME Supplies",
    folderMapping: "DME Supplies",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "autonomy",
  },
  [Classification.IDENTIFICATION_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "No assignment",
    displayName: "ID/DL/Passport",
    documentLabel: "{{ dateReceived YYYYMMDD }} Patient ID",
    folder: "Patient Documents",
    folderMapping: "Patient Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IDENTIFICATION_CARD,
    group: "autonomy",
  },
  [Classification.IMAGING_RESULTS_EEG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo:
      "if marked as urgent: {Rendering Provider} - follow TE assignment logic\nif no marking: {Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Imaging Results- EEG",
    documentLabel: "{{ dateReceived YYYYMMDD }} - EEG Results",
    folder: "EEG",
    folderMapping: "EEG",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EEG,
    group: "autonomy",
  },
  [Classification.IMAGING_RESULTS_EMG]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo:
      "if marked as urgent: {Rendering Provider} - follow TE assignment logic\nif no marking: {Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Imaging Results- EMG",
    documentLabel: "{{ dateReceived YYYYMMDD }} - EMG Results",
    folder: "EMG",
    folderMapping: "EMG",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_EMG,
    group: "autonomy",
  },
  [Classification.IMAGING_RESULTS_MRI]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo:
      "if marked as urgent: {Rendering Provider} - follow TE assignment logic\nif no marking: {Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Imaging Results- MRI",
    documentLabel: "{{ dateReceived YYYYMMDD }} - MRI Results",
    folder: "Imaging",
    folderMapping: "Imaging",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_MRI,
    group: "autonomy",
  },
  [Classification.IMAGING_RESULTS_OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Imaging Results- Other",
    documentLabel: "{{ dateReceived YYYYMMDD }} - {{ imagingType }} Results",
    folder: "Imaging",
    folderMapping: "Imaging",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS_OTHER,
    group: "autonomy",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "Amanda Scroggins",
    displayName: "Insurance cards",
    documentLabel: "{{ dateReceived YYYYMMDD }} Patient Insurance",
    folder: "Insurance Cards",
    folderMapping: "Insurance Cards",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "autonomy",
  },
  [Classification.INTAKE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "No assignment",
    displayName: "Demographics",
    documentLabel: "{{ dateReceived YYYYMMDD }} Patient Demographics",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INTAKE,
    group: "autonomy",
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Lab results",
    documentLabel: "{{ dateReceived YYYYMMDD }} Lab Results",
    folder: "Lab",
    folderMapping: "Lab",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "autonomy",
  },
  [Classification.LAB_RESULTS_ORDER_FORM_NEEDS_SIGNATURE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Order Form Needs Signature",
    documentLabel: "{{ dateReceived YYYYMMDD }} Patient Forms",
    folder: "Outside Orders",
    folderMapping: "Outside Orders",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS_ORDER_FORM_NEEDS_SIGNATURE,
    group: "autonomy",
  },
  [Classification.MEDICAL_HISTORY]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Medical History",
    documentLabel: "{{ dateReceived YYYYMMDD }} Medical History",
    folder: "Outside Records > Medical Records",
    folderMapping: "Outside Records > Medical Records",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_HISTORY,
    group: "autonomy",
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "Group, Healthmark",
    displayName: "Medical records Release/Request - when record are requested of us",
    documentLabel: "{{ dateReceived YYYYMMDD }} Office Medical Records Request",
    folder: "Record Requests / Consent",
    folderMapping: "Record Requests / Consent",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "autonomy",
  },
  [Classification.OTHER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Patient Forms",
    documentLabel: "{{ dateReceived YYYYMMDD }} Patient Forms",
    folder: "Chart Documents",
    folderMapping: "Chart Documents",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.OTHER,
    group: "autonomy",
  },
  [Classification.PHARMACY_RELATED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Anything Rx Related",
    documentLabel: "{{ dateReceived YYYYMMDD }} RX Related",
    folder: "RX",
    folderMapping: "RX",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED,
    group: "autonomy",
  },
  [Classification.PRIOR_AUTHORIZATION]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Prior Auth Update / Status",
    documentLabel: "{{ dateReceived YYYYMMDD }} Prior Auth {{authorizationStatus}}",
    folder: "Referrals/Auths",
    folderMapping: "Referrals/Auths",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION,
    group: "autonomy",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "{Rendering Provider - MA} - follow MA assignment logic",
    displayName: "Progress Notes (if existing/established patient in system)",
    documentLabel: "{{ dateReceived YYYYMMDD }} OV - {{ provider }}",
    folder: "Consultations / Follow Ups",
    folderMapping: "Consultations / Follow Ups",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "autonomy",
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health", "See Referral TE Enums"],
    assignedTo: "{Rendering Provider - Staff} - follow Staff assignment logic",
    displayName: "Patient Referral",
    documentLabel: "{{ dateReceived YYYYMMDD }} Referral from {{referringProvider}}",
    folder: "Referrals",
    folderMapping: "Referrals",
    inputDate: "Date Received",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    classification: Classification.REFERRAL,
    group: "autonomy",
  },
  [Classification.REFERRAL_STATUS_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Scanned By: Integration, Autonomy Health"],
    assignedTo: "Coile, Lauren",
    displayName: "Referral Status",
    documentLabel: "{{ dateReceived YYYYMMDD }} Referral Status",
    folder: "Outside Records > Referrals",
    folderMapping: "Outside Records > Referrals",
    inputDate: "Date Received",
    instructions: null,
    markAsReviewed: true,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_STATUS_REQUEST,
    group: "autonomy",
  },
} as const;
